import(/* webpackMode: "eager" */ "/home/nexts/pw-master-front/app/[locale]/page.tsx");
